import { createSelector } from '@reduxjs/toolkit';
const getMatchedPF = (state) => state.matchedPF.data;
const getLoading = (state) => state.matchedPF.loading;
const getMatchedPFCount = (state) => state.matchedPF.data.length;
const makeMatchedPF = createSelector([getMatchedPF], (matchedPFs) => {
    return matchedPFs.map((matchedPF) => {
        const { privateFoundations = {}, ...matched } = matchedPF;
        const { organizationUrl = '', organizationDescription = '', contriPaidDsbrsChrtblAmt: disbursedCharityAmount = 0, ...pf } = privateFoundations;
        const formattedCharityAmount = disbursedCharityAmount.toLocaleString('en-US');
        return {
            ...pf,
            ...matched,
            organizationUrl,
            formattedCharityAmount,
            disbursedCharityAmount,
            organizationDescription,
        };
    });
});
const makeMatchedPFMetrics = createSelector([makeMatchedPF], (matchedPFs) => {
    const totalPFAmount = matchedPFs.reduce((acc, curr) => acc + curr.disbursedCharityAmount, 0);
    const totalPFs = matchedPFs.length;
    const avgPFAmount = totalPFAmount / totalPFs;
    return { totalPFAmount, totalPFs, avgPFAmount };
});
export const MatchedPFSelectors = {
    getMatchedPF,
    getLoading,
    getMatchedPFCount,
    makeMatchedPF,
    makeMatchedPFMetrics,
};
